export default {
  logged: null
}
